<script setup lang="ts">
import CircleCloseIcon from '@/assets/icons/shared/circle/close.svg';
import UiButton from '@/modules/ui/components/ui/UiButton.vue';

const { label = 'ui.common.button.cancel', iconOnly = false } = defineProps<{
  label?: string;
  iconOnly?: boolean;
}>();
</script>

<template>
  <UiButton
    color="white"
    :shape="iconOnly ? 'square' : 'auto'"
    :aria-label="iconOnly ? $t(label) : undefined"
  >
    <CircleCloseIcon v-prefix="!iconOnly" />
    <span v-if="!iconOnly">{{ $t(label) }}</span>
  </UiButton>
</template>
